module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('request-status', {
    staticClass: "mt-0",
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.globalRequests.appointmentsv2,
      "message200": false
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.practitioner) ? _c('practitioner-picker', {
    model: {
      value: (_vm.practitioner),
      callback: function($$v) {
        _vm.practitioner = $$v
      },
      expression: "practitioner"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "id": "appointment-create-container"
    }
  }, [_c('v-window', {
    attrs: {
      "touchless": "",
      "vertical": "",
      "min-height": 500
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('v-sheet', {
    attrs: {
      "height": "100%",
      "min-height": 500,
      "flat": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "tile": "",
            "outline": _vm.appointment.is_custom,
            "color": "accent"
          },
          on: {
            "click": function($event) {
              _vm.appointment.is_custom = false
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v("Normal appointment")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Use this when creating a normal appointment for a client")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1 mr-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "tile": "",
            "outline": !_vm.appointment.is_custom,
            "color": "accent"
          },
          on: {
            "click": function($event) {
              _vm.appointment.is_custom = true
            }
          }
        }, 'v-btn', attrs, false), on), [_vm._v("Personal appointment")])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Use this to create an appointment for yourself - you can use this to block time out from your calendar")])])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.appointment.is_custom) ? _c('v-text-field', {
    staticClass: "mb-1",
    attrs: {
      "persistent-hint": "",
      "name": "input-title",
      "label": "Appointment title",
      "hint": "Give the appointment a name. e.g.: Lunch, Yoga, Gym, Meeting with Jane etc.",
      "id": "appointment-title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    class: {
      'mb-4': _vm.$vuetify.breakpoint.xs
    },
    attrs: {
      "two-line": "",
      "avatar": "",
      "subheader": ""
    }
  }, [(!_vm.appointment.is_custom) ? _c('v-list-tile', {
    class: _vm.getStepClasses("product"),
    nativeOn: {
      "click": function($event) {
        _vm.productpicker = !_vm.productpicker
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.product && _vm.appointment.product.title) ? _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.appointment.product.title) + "\n                ")]) : _c('v-list-tile-title', [_vm._v("\n                  Type of appointment\n                ")]), _vm._v(" "), (_vm.appointment.product && _vm.appointment.product.duration) ? _c('v-list-tile-sub-title', [_vm._v("\n                  " + _vm._s(_vm.appointment.product.duration) + " mins.\n                  " + _vm._s(_vm.appointment.product.currency) + " " + _vm._s(_vm.appointment.product.price) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.selectedServiceTitle) ? _c('v-list-tile-sub-title', [_vm._v("@ " + _vm._s(_vm.selectedServiceTitle) + "\n                  "), (_vm.appointment && _vm.appointment.address) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("location_on")]), _vm._v("\n                    " + _vm._s(_vm.appointment.address.name))], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.product && _vm.appointment.product.title) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.appointment && _vm.appointment.product && _vm.appointment.product.comes_to_you === true) ? _c('v-list-tile', [_c('v-text-field', {
    staticClass: "mx-4",
    attrs: {
      "prepend-icon": "location_on",
      "label": "Appointment Address",
      "hint": "(optional), store the custom address for this appointment"
    },
    model: {
      value: (_vm.appointmentLocation),
      callback: function($$v) {
        _vm.appointmentLocation = $$v
      },
      expression: "appointmentLocation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.appointment && _vm.appointment.product && _vm.appointment.product.is_online === true) ? [_c('v-divider'), _vm._v(" "), (_vm.hasZoomIntegration) ? _c('div', {
    staticClass: "caption amber lighten-2 mx-4"
  }, [_c('v-icon', {
    staticClass: "mt-2 mr-2 float-left",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption py-0 px-1",
    staticStyle: {
      "float": "right",
      "height": "24px"
    },
    attrs: {
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.overrideZoomIntegration = true
      }
    }
  }, [_vm._v("Manually enter meeting URL")]), _vm._v("\n              Zoom integration detected."), _c('br'), _vm._v("\n              A Zoom meeting will be created for this appointment\n            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.hasZoomIntegration || _vm.overrideZoomIntegration) ? _c('v-list-tile', [_c('v-text-field', {
    staticClass: "mx-4 caption",
    attrs: {
      "persistent-hint": "",
      "prepend-icon": "language",
      "label": "Provide a meeting URL",
      "hint": "(optional) If you don't have the Zoom integration, you can manually provide a meeting URL, or you can provide a custom URL if you do not want AppointmentGuru to generate a custom Zoom meeting for you"
    },
    model: {
      value: (_vm.appointmentURL),
      callback: function($$v) {
        _vm.appointmentURL = $$v
      },
      expression: "appointmentURL"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    class: _vm.getStepClasses("day"),
    on: {
      "click": function($event) {
        _vm.daymodal = true
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [(!_vm.appointment.day) ? _c('v-list-tile-title', [_vm._v("Day")]) : _c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.dateformat(_vm.appointment.day, 'ddd DD MMM')) + "\n              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("click to change selected day")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-5 hidden-sm-and-up",
          attrs: {
            "fab": "",
            "small": "",
            "fixed": "",
            "bottom": "",
            "left": "",
            "color": "info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showcalendar = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("event")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show schedule")])]), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.day) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.daymodal),
      callback: function($$v) {
        _vm.daymodal = $$v
      },
      expression: "daymodal"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    attrs: {
      "full-width": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    model: {
      value: (_vm.appointment.day),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "day", $$v)
      },
      expression: "appointment.day"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.daymodal = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    class: _vm.getStepClasses("time"),
    on: {
      "click": function($event) {
        _vm.starttime = true
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.starttime),
      callback: function($$v) {
        _vm.starttime = $$v
      },
      expression: "starttime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    on: {
      "click": _vm.setDefaultStartTime
    },
    slot: "activator"
  }, [(!_vm.appointment.start_time) ? _c('span', [_vm._v("Start time")]) : _c('span', [_vm._v(_vm._s(_vm.appointment.start_time))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    on: {
      "input": _vm.startTimeChanged
    },
    model: {
      value: (_vm.appointment.start_time),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "start_time", $$v)
      },
      expression: "appointment.start_time"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.starttime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.starttime = false;
        _vm.endtime = true
      }
    }
  }, [_vm._v("Choose end time "), _c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_forward")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "325"
    },
    model: {
      value: (_vm.endtime),
      callback: function($$v) {
        _vm.endtime = $$v
      },
      expression: "endtime"
    }
  }, [_c('v-chip', {
    attrs: {
      "slot": "activator",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setDefaultEndTime.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [(!_vm.appointment.end_time) ? _c('span', [_vm._v("End time")]) : _c('span', [_vm._v(_vm._s(_vm.appointment.end_time))])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "min": _vm.appointment.start_time,
      "scrollable": "",
      "format": "24hr",
      "autosave": ""
    },
    model: {
      value: (_vm.appointment.end_time),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "end_time", $$v)
      },
      expression: "appointment.end_time"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.endtime = false;
        _vm.starttime = true
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Change start time")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.endtime = false
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  Choose a start and end time\n                ")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.start_time && _vm.appointment.end_time) ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isProductSelected) ? _c('div', {
    staticClass: "overline pl-4 grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "nudge-bottom": "",
      "absolute": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.operatingHours) ? [_c('v-icon', {
          staticClass: "hidden-xs-only",
          attrs: {
            "color": "primary",
            "small": ""
          }
        }, [_vm._v("alarm")]), _vm._v(" "), _c('v-chip', {
          staticClass: "v-chip--x-small",
          attrs: {
            "label": "",
            "outline": ""
          }
        }, [_vm._v(_vm._s(_vm.practitionerName))]), _vm._v("\n                      " + _vm._s(_vm.dateformat(_vm.appointment.day, 'ddd')) + "\n                      @ " + _vm._s(_vm.appointment.address.name) + ":\n                      "), _c('strong', [_vm._v(_vm._s(_vm.selectedDayHours))]), _vm._v(" "), _c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "icon": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)] : [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": "",
            "color": "amber"
          }
        }, [_vm._v("warning")]), _vm._v("\n                      Unable to load operating hours\n                      "), _c('v-spacer'), _vm._v(" "), (_vm.operationHoursLink && _vm.appointmentServiceId) ? _c('v-btn', {
          attrs: {
            "flat": "",
            "small": "",
            "href": _vm.operationHoursLink,
            "target": "_blank",
            "disabled": !_vm.rolesIsOwnerOfSpace(_vm.appointmentServiceId)
          }
        }, [_vm._v("Edit hours")]) : _vm._e()]]
      }
    }], null, false, 1287228531)
  }, [_vm._v(" "), (_vm.operatingHours) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "subheader": "",
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 my-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.practitionerName) + " @ " + _vm._s(_vm.appointment.address.name) + ":\n                      "), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return [_c('v-list-tile', {
      key: day
    }, [_c('v-list-tile-content', {
      staticClass: "text-capitalize"
    }, [(day in _vm.operatingHours && _vm.operatingHours[day]) ? _c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(day))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding-left": "20px"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.formatHours(_vm.operatingHours[day])) + "\n                            ")])]) : _c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(day))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "padding-left": "20px"
      }
    }, [_vm._v("Not available")])])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + day)
    })]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.operationHoursLink && _vm.appointmentServiceId) ? _c('v-list-tile', [_c('v-btn', {
    attrs: {
      "block": "",
      "small": "",
      "flat": "",
      "href": _vm.operationHoursLink,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.appointmentServiceId),
      "target": "_blank"
    }
  }, [_vm._v("Edit hours\n                        "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.appointment.is_custom && _vm.isProductSelected),
      expression: "!appointment.is_custom && isProductSelected"
    }],
    class: _vm.getStepClasses("client"),
    on: {
      "click": function($event) {
        _vm.clientmodal = true;
        _vm.clientToucher++
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("person_add")])], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.client && _vm.appointment.client.first_name) ? _c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(_vm.formatFullName(_vm.selectedRelationship)) + "\n                ")]) : _c('v-list-tile-title', [_vm._v("Contact person")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  Click to change")]), _vm._v(" "), (_vm.appointment.client && !_vm.clientIsSharedWithSelectedSpace) ? _c('v-list-tile-sub-title', {
    staticClass: "warning--text"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                  This client will automatically be shared with the space " + _vm._s(_vm.appointmentServiceTitle) + "\n                ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.relationshipId && _vm.practitionerId && _vm.appointment.day) ? _c('v-list-tile-action', [_c('automation-indicator', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "practitioner-id": _vm.practitionerId,
      "product-id": _vm.formattedAppointment.product,
      "dt": _vm.appointment.day
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.relationshipId) ? _c('v-list-tile-action', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "ml-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-action', [(_vm.appointment.client && _vm.appointment.client.id) ? _c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("task_alt")]) : _c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("arrow_back")])], 1)], 1), _vm._v(" "), (_vm.appointment.client && _vm.appointment.client.id) ? _c('div', {
    staticClass: "overline pl-3 pt-1 grey lighten-4"
  }, [_c('v-divider'), _vm._v(" "), (!_vm.hasContacts) ? [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No contact info\n              ")], 1)] : [(_vm.clientPhoneNumber) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientPhoneNumber) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No phone no.\n              ")], 1), _vm._v(" "), (_vm.clientEmail) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientEmail) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No email\n              ")], 1)], _vm._v(" "), _c('v-divider')], 2) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": true,
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.clientmodal),
      callback: function($$v) {
        _vm.clientmodal = $$v
      },
      expression: "clientmodal"
    }
  }, [_c('client-picker-dialog', {
    attrs: {
      "can-clear-space": false,
      "space-id": _vm.spaceId,
      "include-owned-by-me": true,
      "touch": _vm.clientToucher
    },
    on: {
      "clientselected": _vm.clientSelected,
      "relationshipselected": _vm.relationshipSelected,
      "close": function($event) {
        _vm.clientmodal = false
      }
    }
  })], 1), _vm._v(" "), (_vm.appointment.client && _vm.appointment.client.first_name) ? _c('section', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-spacer'), _vm._v(" "), (!_vm.selectCustomTitle) ? _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectCustomTitle = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n                      Add a dependant")], 1) : _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.selectCustomTitle = false;
        _vm.appointment.title = ""
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), (_vm.selectCustomTitle) ? [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "outline": "",
      "persistent-hint": "",
      "name": "input-title",
      "hint": "Dependant's name will show on calendar and invoices. Appointment is attached to the contact person's account",
      "label": "Dependant's full name",
      "id": "appointment-title"
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.appointmentIsValid && _vm.selectCustomTitle) ? _c('span', {
    staticClass: "mr-4"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                Appointment will be stored under " + _vm._s(_vm.clientFirstName) + "\n              ")], 1) : _vm._e()])], 1), _vm._v(" "), (!_vm.appointmentIsValid) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "orange--text"
  }, [_vm._v("\n              " + _vm._s(_vm.invalidReason) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.isReadOnly === true) ? _c('read-only-block', {
    attrs: {
      "xs12": "",
      "text": "This account is in read-only mode. Please resolve the account status in order to create new appointments"
    }
  }) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.savedAppointment && _vm.savedAppointment.id) ? _c('appointments-after-actions', {
    attrs: {
      "appointment": _vm.savedAppointment
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      },
      "reset": _vm.clear
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 0),
      expression: "step===0"
    }],
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.saveRequest.loading,
      "disabled": !_vm.appointmentIsValid
    },
    on: {
      "click": function($event) {
        _vm.confirmAndCreate = true
      }
    }
  }, [_vm._v("Confirm and create")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), (_vm.appointment.day) ? _c('practitioner-day-view', {
    staticClass: "mr-3 mt-2 elevation-10",
    attrs: {
      "with-week": "",
      "with-date-bar": "",
      "block-events": "",
      "with-fetch": false,
      "practitioner": _vm.practitioner,
      "date": _vm.appointment.day,
      "settings": _vm.dayViewSettings,
      "preview-event": _vm.appointmentPreview
    },
    on: {
      "update:date": function($event) {
        return _vm.$set(_vm.appointment, "day", $event)
      },
      "dayview:createevent": _vm.slotSelected
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "scrollable": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.showcalendar),
      callback: function($$v) {
        _vm.showcalendar = $$v
      },
      expression: "showcalendar"
    }
  }, [(_vm.appointment.day) ? _c('v-card', {
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline grey darken-4 py-1 white--text"
  }, [_vm._v("\n        Schedule for " + _vm._s(_vm.dateformat(_vm.appointment.day)) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showcalendar = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.day) ? _c('practitioner-day-view', {
    attrs: {
      "with-week": "",
      "with-date-bar": "",
      "block-events": "",
      "with-fetch": false,
      "practitioner": _vm.practitioner,
      "date": _vm.appointment.day,
      "settings": _vm.dayViewSettings,
      "preview-event": _vm.appointmentPreview
    },
    on: {
      "update:date": function($event) {
        return _vm.$set(_vm.appointment, "day", $event)
      },
      "dayview:createevent": _vm.slotSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sheetdateselected),
      expression: "sheetdateselected"
    }],
    staticClass: "success",
    attrs: {
      "fab": "",
      "small": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": function($event) {
        _vm.showcalendar = false
      }
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('product-sheet', {
    attrs: {
      "visible": _vm.productpicker,
      "practitioner": _vm.practitioner
    },
    on: {
      "selectedservice": _vm.productSelected
    }
  }), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "inset": ""
    },
    model: {
      value: (_vm.confirmAndCreate),
      callback: function($$v) {
        _vm.confirmAndCreate = $$v
      },
      expression: "confirmAndCreate"
    }
  }, [_c('confirm-appointment', {
    attrs: {
      "practitioner": _vm.practitioner,
      "appointment": _vm.appointment,
      "loading": _vm.saveRequest.loading
    },
    on: {
      "close": function($event) {
        _vm.confirmAndCreate = false
      },
      "confirm": _vm.confirmAndSave
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7d2c92a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/Create.vue
// module id = 1550
// module chunks = 9